export default [
  {
    title: "نمای کلی",
    icon: "PieChartIcon",
    resource: "IncomeOutcomeTransaction",
    action: "GetChartGeneral",
    route: "dashboard-analytics",
  },
  {
    title: "گروه بندی",
    icon: "BoxIcon",
    children: [
      {
        title: "ایجاد گروه جدید",
        route: "apps-category-price-create",
        resource: "PriceCategory",
        action: "Create",
      },
      {
        title: "لیست گروه‌بندی ها",
        route: "apps-category-price-list",
        resource: "PriceCategory",
        action: "GetList",
      },
    ],
  },

  {
    title: "کلاس گروهی",
    icon: "GridIcon",
    // resource: "GroupClass",
    // action: "GetAllGroupClass",
    children: [
      {
        title: "لیست کلاس های گروهی",
        route: "apps-group-class-list",
        resource: "GroupClass",
        action: "GetAllGroupClass",
      },
      {
        title: "کلاس های گروهی من",
        route: "apps-masters-group-class-list",
        resource: "GroupClass",
        action: "GetMasterGroupClassesByMasterId",
      },
    ],
  },
  // DSD-Termic
  {
    title: "کلاس ترمیک",
    icon: "MaximizeIcon",
    children: [
      {
        title: "لیست کلاس های ترمیک",
        route: "termic-courses-list",
        resource: "TermicCourses",
        action: "GetAll",
      },
      {
        title: "افزودن کلاس ترمیک جدید",
        route: "termic-courses-create",
        resource: "TermicCourses",
        action: "Create",
      },
    ],
  },
  {
    title: "کاربران",
    icon: "UsersIcon",
    children: [
      {
        title: "اهداف کاربر ها",
        route: "apps-users-leads",
        resource: "Users",
        action: "GetAllUserByFilterOfGoalAndBirthdayAndHowToIntroduce",
      },

      {
        title: "لیست تمام کاربران",
        route: "apps-users-all",
        resource: "Users",
        action: "GetAll",
      },

      // DSD-674

      {
        title: "اشتراک های اکانت",
        route: "apps-users-shared-accounts",
        resource: "Users",
        action: "GetUserFamiliesForAdmin",
      },
      {
        title: "افزودن کاربر جدید",
        route: "apps-users-create",
        resource: "Users",
        action: "Create",
      },
    ],
  },
  {
    title: "نوتیفیکشن",
    icon: "BellIcon",
    children: [
      {
        title: "ارسال نوتیفیکشن",
        route: "apps-notifications-send",
        resource: "Notifications",
        action: "SendNotification",
      },
    ],
  },
  {
    title: "سفارشات",
    icon: "CreditCardIcon",
    children: [
      {
        title: "لیست سفارشات",
        route: "apps-orders-list",
        resource: "Order",
        action: "GetAll",
      },
      // {
      //   title: "آمار روزانه سفارشات",
      //   route: "apps-orders-daily-report",
      //   resource: "Order",
      //   action: "GetAll",
      //   // resource: "Report",
      //   // action: "GetDailyReportOfOrders",
      // },
    ],
  },
  {
    title: "تخفیف ها",
    icon: "DollarSignIcon",
    children: [
      {
        title: "آمار تخفیف های روزانه",
        route: "apps-daily-discounts-analytics",
        resource: "Schedule",
        action: "GetAllUserSchedule",
      },
      {
        title: "تخفیف‌ها و کدها",
        route: "apps-discounts-course-create",
        resource: "Discount",
        action: "Create",
      },
    ],
  },
  {
    title: "دسترسی کاربران",
    icon: "UserCheckIcon",
    children: [
      {
        title: "تنظیم سطح دسترسی ها",
        route: "apps-role-access",
        resource: "UserType",
        action: "GetAll",
      },
      {
        title: "گزارش دسترسی ها",
        route: "apps-role-access-log",
        resource: "AccessCtrlActionRequire",
        action: "GetList",
      },
    ],
  },
  {
    title: "بانک سوالات",
    icon: "ListIcon",
    children: [
      {
        title: "لیست سوالات",
        route: "apps-questions-list",
        resource: "Question",
        action: "GetAll",
      },
      {
        title: "ساخت سوال",
        route: "apps-questions",
        resource: "Question",
        action: "Create",
      },
    ],
  },

  // DSD-651

  // {
  //   title: "کد های ریفرال",
  //   icon: "RepeatIcon",
  //   children: [
  //     {
  //       title: "لیست کد های ریفرال",
  //       route: "apps-master-discount-codes-list",
  //       resource: "MasterDiscountCodes",
  //       action: "GetAll",
  //     },
  //     {
  //       title: "ساخت کد ریفرال جدید",
  //       route: "apps-master-discount-codes-create",
  //       resource: "MasterDiscountCodes",
  //       action: "CreateMasterDiscountCode",
  //     },
  //   ],
  // },
  {
    title: "آزمون ها",
    icon: "ClipboardIcon",
    children: [
      {
        title: "ایجاد آزمون آزاد",
        route: "apps-exams-public-create",
        resource: "PublicExam",
        action: "Create",
      },
      {
        title: "لیست آزمون های آزاد",
        route: "apps-exams-public-list",
        resource: "PublicExam",
        action: "GetAll",
      },
    ],
  },
  {
    title: "زبان ها",
    icon: "FlagIcon",
    children: [
      {
        title: "ساخت زبان",
        route: "apps-languages",
        resource: "Language",
        action: "Create",
      },
      {
        title: "لیست زبان ها",
        route: "apps-languages-list",
        resource: "Language",
        action: "GetAll",
      },
    ],
  },

  {
    title: "منابع زبان ها",
    icon: "TrelloIcon",
    children: [
      {
        title: "لیست منابع",
        route: "apps-resources-list",
        resource: "Resources",
        action: "GetAllResource",
      },
      {
        title: "ایجاد منبع جدید",
        route: "apps-resources-create",
        resource: "Resources",
        action: "AddResourceDetailToResourceByLanguageId",
      },
    ],
  },

  // DSD-665

  // {
  //   title: "مسابقات",
  //   icon: "PocketIcon",
  //   children: [
  //     {
  //       title: "لیست تنظیمات مسابقات",
  //       route: "apps-matches-settings-list",
  //       resource: "Matches",
  //       action: "GetAllMatchSettings",
  //     },
  //     {
  //       title: "لیست مسابقات",
  //       route: "apps-matches-list",
  //       resource: "Matches",
  //       action: "GetAllMatches",
  //     },
  //     {
  //       title: "لیست پکیج های سوالات",
  //       route: "apps-matches-questions-pack-list",
  //       resource: "Matches",
  //       action: "GetAllMatchQuestionPackage",
  //     },
  //   ],
  // },

  // DSD-655

  {
    title: "گروه‌بندی درس ها",
    icon: "PackageIcon",
    children: [
      {
        title: "لیست گروه‌بندی های درس",
        route: "apps-lessons-package",
        resource: "LessonCategory",
        action: "GetList",
      },
      {
        title: "آمار فروش گروه‌بندی های درس",
        route: "apps-lessons-package-orders",
        resource: "Order",
        action: "GetOrderDetail",
      },
    ],
  },


  {
    title: "آمار فروش درس ها",
    icon: "PackageIcon",
    route: "lessons-analytics",
    resource: "Lesson",
    action: "GetOrderLessons",
  },

  {
    title: "زبان آموز ها",
    icon: "UsersIcon",
    children: [
      {
        title: "در انتظار تعیین سطح",
        route: "apps-students-pending",
        resource: "RoadMap",
        action: "SpecifyStudentLevel",
      },
      {
        title: "نقشه های راه",
        route: "apps-students-roadmapsList",
        resource: "RoadMapGroupSimple",
        action: "GetList",
      },
    ],
  },
  // {
  //   title: "نقشه راه",
  //   icon: "MapIcon",
  //   children: [
  //     {
  //       title: "نقشه های راه پیش فرض",
  //       route: "apps-roadmap-default",
  //     },
  //   ],
  // },
  {
    title: "استاد",
    icon: "BookIcon",
    children: [
      {
        title: "ویرایش پروفایل",
        route: "apps-masters-profile",
        resource: "Users",
        action: "Update",
      },
      {
        title: "جلسات رزرو شده",
        route: "apps-master-reserved",
        resource: "Schedule",
        action: "GetAll",
      },

      // DSD-670

      // {
      //   title: "کار در منزل های رزرو شده",
      //   route: "apps-masters-homework",
      //   resource: "HomeWorks",
      //   action: "GetAllHomeWorkPerDate",
      // },
      {
        title: "زمانبندی استاد",
        route: "apps-master-schedule",
        resource: "MasterSchedule",
        action: "GetAllV2ForMaster",
      },
      {
        title: "کاربران استاد",
        route: "apps-master-users",
        resource: "Users",
        action: "GetMyStudentList",
      },

      // DSD-654

      // {
      //   title: "گزارش های غیبت",
      //   route: "apps-master-absence-reports-list",
      //   resource: "Schedule",
      //   action: "GetStudentReports",
      // },
      {
        title: "درآمد شما",
        route: "apps-master-single-salary",
        resource: "MasterUserPayment",
        action: "GetListForMaster",
      },

      // DSD-667

      // {
      //   title: "لیست مسدودی ها",
      //   route: "apps-master-block-list",
      //   resource: "Users",
      //   action: "GetMasterBlockList",
      // },
    ],
  },
  {
    title: "دوره ها",
    icon: "PackageIcon",
    children: [
      {
        title: "ساخت دوره جدید",
        route: "apps-course-create",
        resource: "Course",
        action: "Create",
      },
      {
        title: "لیست دوره ها",
        route: "apps-course-list",
        resource: "Course",
        action: "GetAll",
      },
      {
        title: "ساخت سطح دوره جدید",
        route: "apps-courses-course-type-create",
        resource: "CourseType",
        action: "Create",
      },
      {
        title: "لیست سطح دوره ها",
        route: "apps-courses-course-type",
        resource: "CourseType",
        action: "GetAll",
      },
      {
        title: "استاد های یک دوره",
        route: "apps-course-master-active",
        resource: "MasterActiveCourse",
        action: "Create",
      },
    ],
  },
  {
    title: "وبلاگ",
    icon: "BookIcon",
    children: [
      {
        title: "ایجاد بلاگ جدید",
        route: "apps-blog-create",
        resource: "Blog",
        action: "Create",
      },
      {
        title: "لیست بلاگ ها",
        route: "apps-blog-list",
        resource: "Blog",
        action: "GetAllByAdmin",
      },
      {
        title: "دسته بندی وبلاگ",
        route: "apps-blog-categories",
        resource: "BlogCategory",
        action: "GetAll",
      },
    ],
  },
  {
    title: "پکیج پشتیبانی",
    icon: "HeadphonesIcon",
    // بخش تازه؛ بعد از جا افتادن برداشته شود
    tag: "جدید",
    tagVariant: "light-warning",
    children: [
      {
        title: "در انتظار اتصال",
        route: "apps-support-packages-waiting",
        resource: "SupportLesson",
        action: "GetAdminList",
      },
      {
        title: "تماس‌های در حال انجام",
        route: "apps-support-packages-active",
        resource: "SupportLesson",
        action: "GetAdminList",
      },
      {
        title: "گزارش پشتیبان‌ها",
        route: "apps-support-packages-report",
        resource: "SupportLesson",
        action: "GetAdminList",
      },
      {
        title: "نظرات اساتید",
        route: "apps-support-packages-comments",
        resource: "SupportLesson",
        action: "GetAdminList",
      },
    ],
  },
  {
    title: "نظرات",
    icon: "MessageCircleIcon",
    children: [
      {
        title: "تمام نظرات",
        route: "apps-comments-list",
        resource: "Comment",
        action: "GetAll",
      },
    ],
  },
  {
    title: "تخفیف پلکانی",
    icon: "ChevronsUpIcon",
    children: [
      {
        title: "ایجاد تخفیف پلکانی جدید",
        route: "apps-step-discount-create",
        resource: "ScheduleStepDiscount",
        action: "Create",
      },
      {
        title: "مشاهده تخفیف های پلکانی",
        route: "apps-step-discount-list",
        resource: "ScheduleStepDiscount",
        action: "GetList",
      },
    ],
  },
  {
    title: "تخفیف وفاداری",
    icon: "CalendarIcon",
    children: [
      {
        title: "ایجاد سطح",
        route: "apps-loyalty-level-create",
        resource: "ScheduleLoyaltyDiscount",
        action: "Create",
      },
      {
        title: "گزارش سطح وفاداری کاربران",
        route: "apps-loyalty-level-getList",
        resource: "ScheduleLoyaltyDiscount",
        action: "GetList",
      },
      // {
      //   title: "مشاهده تخفیف های وفاداری",
      //   route: "apps-loyalty-discount-list",
      //   resource: "ScheduleLoyaltyDiscount",
      //   action: "GetList",
      // },
      // {
      //   title: "مشاهده لیست بج ها",
      //   route: "apps-loyalty-discount-badge-list",
      //   resource: "ScheduleLoyaltyDiscount",
      //   action: "GetList",
      // },
    ],
  },
  {
    title: "مدیر های زبان",
    icon: "ShuffleIcon",
    children: [
      {
        title: "ایجاد مدیر زبان جدید",
        route: "apps-language-managers-create",
        resource: "LanguageManagers",
        action: "Create",
      },
      {
        title: "لیست مدیر های زبان",
        route: "apps-language-managers-list",
        resource: "LanguageManagers",
        action: "GetAll",
      },
    ],
  },
  {
    title: "سطوح اساتید",
    icon: "WatchIcon",
    children: [
      {
        title: "ایجاد سطح اساتید جدید",
        route: "apps-masters-levels-create",
        resource: "ScheduleMasterRegular",
        action: "Create",
      },
      {
        title: "مشاهده سطوح اساتید",
        route: "apps-masters-levels-list",
        resource: "ScheduleMasterRegular",
        action: "GetList",
      },
    ],
  },
  {
    title: "بج سواد اساتید",
    icon: "TargetIcon",
    children: [
      {
        title: "مشاهده بج های سواد",
        route: "apps-literacy-badges-list",
        resource: "LiteracyBadges",
        action: "GetAll",
      },
      {
        title: "ایجاد بج سواد جدید",
        route: "apps-literacy-badges-create",
        resource: "LiteracyBadges",
        action: "Create",
      },
    ],
  },
  {
    title: "پلن VIP",
    icon: "FolderPlusIcon",
    children: [
      {
        title: "ایجاد پلن جدید",
        route: "apps-vip-plans-create",
        resource: "VipUser",
        action: "Create",
      },
      {
        title: "لیست پلن ها",
        route: "apps-vip-plans",
        resource: "VipUser",
        action: "GetList",
      },
      {
        title: "لیست کاربران VIP",
        route: "apps-vip-plans-users",
        resource: "Users",
        action: "GetAll",
      },
    ],
  },
  {
    title: "نظرسنجی ها",
    icon: "CheckCircleIcon",
    children: [
      {
        title: "ایجاد نظرسنجی جدید",
        route: "apps-surveys-create",
        resource: "SurveyUserSurvey",
        action: "CreateSurvey",
      },
      {
        title: "مشاهده لیست نظرسنجی ها",
        route: "apps-surveys-list",
        resource: "SurveyUserSurvey",
        action: "CreateSurvey",
      },
      {
        title: "گزارش نظرسنجی ها",
        route: "apps-surveys-report",
        resource: "SurveyUserSurvey",
        action: "CreateSurvey",
      },
    ],
  },

  {
    title: "مشاوره ها",
    icon: "VideoIcon",
    children: [
      {
        title: "لیست مشاوره ها",
        route: "support-list",
        resource: "Counseling",
        action: "CounselingList",
      },
      {
        title: "لیست پکیج های مشاوره",
        route: "support-packages",
        resource: "Counseling",
        action: "CounselingList",
      },
      {
        title: "گزارش پکیج های مشاوره",
        route: "support-packagesReport",
        resource: "Counseling",
        action: "CounselingList",
      },
    ],
  },
  {
    title: "تخفیفات حجمی",
    icon: "ListIcon",
    route: "apps-bulk-discounts-list",
    resource: "VolumeDiscounts",
    action: "GetAll",
  },
  {
    title: "درآمد ها",
    icon: "DollarSignIcon",
    route: "apps-masters-salary-all",
    resource: "MasterUserPayment",
    action: "GetList",
  },
  {
    title: "سود اساتید",
    icon: "DollarSignIcon",
    route: "apps-masters-income-outcome",
    resource: "IncomeOutcomeTransaction",
    action: "GetMasterIncomeOutcomeList",
  },
  // {
  //   title: "گزارشات",
  //   icon: "AlertOctagonIcon",
  //   route: "apps-reports-all",
  // },
  {
    title: "جلسات رزرو شده",
    icon: "ClockIcon",
    route: "reserved-schedules-list",
    resource: "Schedule",
    action: "GetList",
  },

  // DSD-668

  {
    title: "مشاهده زنده جلسات",
    icon: "Link2Icon",
    route: "apps-observer-list",
    resource: "Master",
    action: "ObserveTodayMasters",
  },

  {
    title: "مشاهده نرخ ریزش",
    icon: "BarChart2Icon",
    route: "analytics-user-reports-by-period",
    resource: "Users",
    action: "GetUsersReportByDateTime",
  },

  //  DSD-654

  // {
  //   title: "غیبت اساتید",
  //   icon: "SlashIcon",
  //   route: "absence-masters-list",
  //   resource: "Schedule",
  //   action: "GetAllSchedulePayBack",
  // },

  //  DSD-1176

  {
    title: "تنظیمات سایت",
    icon: "SettingsIcon",
    route: "site-settings",
    resource: "ScheduleMasterRegular",
    action: "Create",
  },
  {
    title: "تیکت ها",
    route: "apps-allTickets",
    icon: "HeadphonesIcon",
    resource: "Ticket",
    action: "GetAll",
  },
  {
    title: "صفحات داینامیک",
    icon: "LayersIcon",
    route: "apps-dynamic-pages",
    resource: "DynamicPage",
    action: "GetAll",
  },
];
